import { render, staticRenderFns } from "./TermsText.vue?vue&type=template&id=36136ed5&scoped=true&"
import script from "./TermsText.vue?vue&type=script&lang=js&"
export * from "./TermsText.vue?vue&type=script&lang=js&"
import style0 from "./TermsText.vue?vue&type=style&index=0&id=36136ed5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36136ed5",
  null
  
)

export default component.exports